import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import Seo from "@/components/Seo";
import { MaskLines, Reveal } from "@/components/Reveal";
import { SERVICES, serviceImage } from "@/data";

const ServicesIndex = () => (
  <div data-testid="services-page">
    <Seo
      title="Security Services Wales | 17 Specialist Services | Xtreme Protection"
      description="Manned guarding, door supervision, CCTV monitoring, mobile patrols, event security, construction site security and 11 more SIA-licensed security services across Wales."
      path="/services"
      altCy="/cy/gwasanaethau"
    />
    <section className="border-b border-[#1C2027] bg-[#0D1015] pb-16 pt-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <p className="eyebrow flex items-center gap-3">
          <span className="h-px w-10 bg-[#F5A800]" />
          The Arsenal // 17 Specialist Services
        </p>
        <MaskLines className="font-condensed mt-6 text-5xl font-bold uppercase leading-[0.9] tracking-tight text-white sm:text-7xl" lines={["Security Services", "For Wales"]} />
        <Reveal delay={0.3}>
          <p className="mt-6 max-w-2xl text-base leading-relaxed text-[#9BA1AB] sm:text-lg">
            Every service delivered by SIA-licensed, BS 7858 vetted officers — layered into packages built from your risk assessment, available in every Welsh town and city we cover.
          </p>
        </Reveal>
      </div>
    </section>

    <section className="mx-auto max-w-7xl px-4 py-16 sm:px-6">
      <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3" data-testid="services-directory-grid">
        {SERVICES.map((s, i) => (
          <Reveal key={s.slug} delay={(i % 3) * 0.07} y={18} className="h-full">
            <Link to={`/services/${s.slug}`} data-testid={`service-tile-${s.slug}`} className="group flex h-full flex-col border border-[#1C2027] bg-[#10131A] transition-colors duration-300 hover:border-[#F5A800]/50">
              <div className="relative h-44 overflow-hidden">
                <img src={serviceImage(i)} alt={`${s.name} services in Wales by Xtreme Protection`} className="h-full w-full object-cover opacity-70 transition-transform duration-700 group-hover:scale-105" loading="lazy" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#10131A] to-transparent" />
                <span className="font-condensed absolute left-4 top-4 bg-[#0A0C10]/80 px-2 py-1 text-xs font-bold text-[#F5A800]">{String(i + 1).padStart(2, "0")}</span>
              </div>
              <div className="flex flex-1 flex-col justify-between p-6">
                <div>
                  <h2 className="font-condensed flex items-start justify-between text-xl font-bold uppercase leading-tight tracking-wide text-white transition-colors duration-300 group-hover:text-[#F5A800]">
                    {s.name} Wales
                    <ArrowUpRight className="h-4 w-4 shrink-0 text-white/30 transition-all duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 group-hover:text-[#F5A800]" />
                  </h2>
                  <p className="mt-2 text-[13px] leading-relaxed text-[#9BA1AB]">{s.short}</p>
                </div>
                <span className="mt-5 text-[10px] font-bold uppercase tracking-[0.24em] text-white/40 transition-colors duration-300 group-hover:text-[#F5A800]">Full service intel →</span>
              </div>
            </Link>
          </Reveal>
        ))}
      </div>
    </section>
  </div>
);

export default ServicesIndex;
